export default __webpack_public_path__ + "static/cover-image-f76563603ee093d9de053f7183c7611b.jpg";